import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Cookie consent. The banner markup and the denied-by-default Consent Mode
// state both live in public/index.html, so analytics storage is already denied
// before this runs. This records the visitor's choice and, on acceptance only,
// tells gtag to grant analytics storage. Element lookups are guarded and
// deferred until the DOM is ready: a missing element at module-execution time
// would otherwise throw and stop the whole bundle running.
const CONSENT_KEY = 'cookieConsent';
const LEGACY_CONSENT_KEY = 'cookiesAccepted';

function readConsent() {
    try {
        const choice = localStorage.getItem(CONSENT_KEY);
        if (choice) {
            return choice;
        }
        // Visitors who accepted under the previous banner are not re-prompted.
        if (localStorage.getItem(LEGACY_CONSENT_KEY) === 'true') {
            return 'granted';
        }
    } catch (e) {
        // localStorage unavailable; treat as undecided and ask again.
    }
    return null;
}

function initCookieConsent() {
    const banner = document.getElementById('cookie-consent');
    if (!banner) {
        return;
    }

    // The banner is hidden in CSS by default, so a visitor who has already
    // chosen never sees it flash, and a JavaScript failure leaves analytics
    // denied rather than silently consenting on the visitor's behalf.
    if (readConsent()) {
        return;
    }
    banner.style.display = 'block';

    const choose = (value) => {
        try {
            localStorage.setItem(CONSENT_KEY, value);
        } catch (e) {
            // Storage unavailable: the choice applies to this page load only.
        }
        if (value === 'granted' && typeof window.gtag === 'function') {
            window.gtag('consent', 'update', { analytics_storage: 'granted' });
        }
        banner.classList.add('hidden');
    };

    const accept = document.getElementById('accept-cookies');
    if (accept) {
        accept.addEventListener('click', () => choose('granted'));
    }

    const reject = document.getElementById('reject-cookies');
    if (reject) {
        reject.addEventListener('click', () => choose('denied'));
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieConsent);
} else {
    initCookieConsent();
}
